export default {
	cache:{}
};



// WEBPACK FOOTER //
// ./src/reducers/exhibit/exhibitCache-initialState.js